<template>
  <DatatableReportV3
    title="Customer Contact Report"
    :config="config"
    :source="source"
    :filters="filters"
    :no-download="noDownload"
  />
</template>

<script>
import { customerClassificationColumns } from "@/lib/customerTypes";

import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    },
    noDownload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // The default sort is by position, so it moves with the classification
    // columns to stay on the same column.
    const classificationColumns = customerClassificationColumns();

    return {
      config: {
        responsive: true,
        order: [[1 + classificationColumns.length, "asc"]],
        columns: [
          { data: "id", orderable: false, responsivePriority: 3 },
          ...classificationColumns,
          { data: "name", className: "name-field", responsivePriority: 1 },
          { data: "email", className: "email-field", responsivePriority: 4 },
          { data: "phone", className: "phone-field", responsivePriority: 2 },
          {
            data: "tags",
            title: "Tags",
            orderable: false,
            searchable: false,
            responsivePriority: 8
          },
          {
            data: "location_name",
            title: "Location Name",
            responsivePriority: 7
          },
          {
            data: "address",
            orderable: false,
            className: "address-field",
            responsivePriority: 5
          },
          {
            data: "primary",
            title: "Billing Address?",
            responsivePriority: 10
          },
          {
            data: "zip_code",
            title: "Zip",
            className: "zipcode-field",
            responsivePriority: 6
          },
          {
            data: "membership_status",
            title: "Member Status",
            searchable: false,
            className: "membership-status-field",
            filterName: "membership_status",
            responsivePriority: 9
          },
          {
            data: "accounting_key",
            title: "Accounting Key",
            searchable: false,
            responsivePriority: 14
          },
          {
            data: "invoice_count",
            title: "# of Invoices",
            className: "text-center",
            orderable: false,
            searchable: false,
            responsivePriority: 13
          },
          {
            data: "most_recent_invoice",
            title: "Last Invoice",
            filterName: "last_job",
            orderable: false,
            searchable: false,
            responsivePriority: 11
          },
          {
            data: "total_invoices_value",
            title: "Total Invoiced",
            className: "text-right",
            orderable: false,
            searchable: false,
            responsivePriority: 12
          },
          {
            data: "customer_created_date",
            title: "Customer Created Date",
            className: "text-center",
            searchable: false,
            responsivePriority: 15
          }
        ],
        vueComponents: [
          {
            rootId: "tag-list-vue",
            component: TagList
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Customer Contact Report" });
  }
};
</script>

<style lang="scss" scoped></style>
